<template>
  <div class="discount-new-credentials-card">
    <new-credentials-card-single-or-joint v-if="!accountType" :source="source" :setAccountType="setAccountType" :accountTypes="accountTypes"/>
    <multi-state-credentials-card v-else-if="accountType === accountTypes.SINGLE" :source="source" />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import Segment from '../../../../Segment';
import SourceFields from '../../../../mixins/SourceFields.vue';
import effects from '../../../../store/utilities/effects';
import NewCredentialsCardSingleOrJoint from './DiscountNewCredentialsCardSingleOrJoint.vue';
import MultiStateCredentialsCard from '../MultiStateCredentialsCard.vue';

export default {
  name: 'DiscountNewCredentialsCardFlow',
  mixins: [SourceFields],
  components: {
    NewCredentialsCardSingleOrJoint,
    MultiStateCredentialsCard,
  },
  props: [
    'source',
    'disableRemove',
  ],
  computed: {
    ...mapState('credentials', ['credentialsList']),
    accountType() {
      return this.source.discountCredentialsType;
    },
    accountTypes() {
      return {
        SINGLE: 'single',
        JOINED: 'joined',
      };
    },
  },
  methods: {
    ...mapActions('credentials', ['deleteCredentials', 'createCredentials', 'setDiscountCredentialsType']),
    async setAccountType(type) {
      Segment.trackUserInteraction('DiscountApiFlow_AccountTypeSelected', { type });
      await this.setDiscountCredentialsType({ credentialsId: this.source.credentialsId, credentialsType: type });
      if (type === this.accountTypes.JOINED) {
        await this.switchToRegularDiscount();
      }
    },
    async switchToRegularDiscount() {
      const newCredentialsId = await this.createCredentials({ sourceName: this.allSourceFields.discount.sourceName });
      this.deleteCredentials({ credentialsId: this.source.credentialsId });
      await effects.scrollToElement(newCredentialsId);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/base-components/credentials/credentials-card/discount/DiscountNewCredentialsCardFlow.vue